import { isNotEmpty } from 'lib/misc';

/**
 * Filter a list of objects by matching key values
 *
 * @param {Array} entities Source list of entities
 * @param {Array} keys Target keys to preserve
 * @param {Function} getKey Key retriever function
 */
export const filterListByKeys = <TEntity>(
  entities: Array<TEntity>,
  keys: Array<string>,
  getKey: (entity: TEntity) => string,
) => entities.filter(entity => keys.includes(getKey(entity)));

/**
 * Filter a map of objects by matching key values
 *
 * @param {Array} entities Source list of entities
 * @param {Array} keys Target keys to preserve
 */
export const filterMapByKeys = <TEntity>(entities: Record<string, TEntity>, keys: Array<string>) =>
  keys.map(key => entities[key]).filter(isNotEmpty);

/**
 * Merge and filter arrays by only preserving unique values
 *
 * @param {Array} arrays Array of arrays to merge and filter
 */
export const filterUnique = <TValue>(...arrays: Array<Array<TValue>>) =>
  arrays
    .reduce((acc, array) => acc.concat(array), [])
    .filter((value, index, array) => array.indexOf(value) === index);

/**
 * Remove all values from the base array that are encountered in the list of exclusions
 *
 * @param {Array} array Array to filter
 * @param {Array} exclusions List of values to exclude from the base array
 */
export const filterWithout = <TValue>(array: Array<TValue>, exclusions: Array<TValue>) =>
  array.filter(value => !exclusions.includes(value));
